import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Priya & Rahul",
      event: "Wedding",
      content: "Amazing photography! They captured every moment perfectly. The photos are beautiful and we love our wedding album.",
      rating: 5
    },
    {
      id: 2,
      name: "Anjali Sharma",
      event: "Pre-Wedding",
      content: "Professional and creative team. Our pre-wedding shoot was beyond our expectations. Highly recommended!",
      rating: 5
    },
    {
      id: 3,
      name: "Karthik & Meera",
      event: "Reception",
      content: "Excellent service and quality. They covered our reception beautifully and delivered photos quickly.",
      rating: 5
    },
    {
      id: 4,
      name: "Divya Patel",
      event: "Engagement",
      content: "Wonderful experience! The team was very cooperative and captured our engagement ceremony perfectly.",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <h2 className="section-title">What Our Clients Say</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p className="testimonial-content">"{testimonial.content}"</p>
              <div className="testimonial-author">
                <h4>{testimonial.name}</h4>
                <p>{testimonial.event}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
